import bridge from './bridge';
import globalConfig from './globalConfig';

const TRACK_EVENT = 'trackEvent';
const NOTIFY_VISIT = 'notifyVisit';

const EVENT_MAP = {
  close: {
    eventName: 'custom_popup_window',
    eventKey: 'close_window'
  },
  getGiftSucc: {
    eventName: 'custom_popup_window',
    eventKey: 'popup_reward_success'
  },
  error: {
    eventName: 'custom_popup_window',
    eventKey: 'popup_reward_failed'
  },
  noLogin1: {
    eventName: 'custom_popup_window',
    eventKey: 'popup_reward_failed',
    msg: '没有登录态1',
    code: '31000'
  },
  noLogin2: {
    eventName: 'custom_popup_window',
    eventKey: 'popup_reward_failed',
    msg: '没有登录态2',
    code: '31001'
  },
  noRole: {
    eventName: 'custom_popup_window',
    eventKey: 'popup_reward_failed',
    msg: '没有角色',
    code: '31002'
  },
  noFitServer: {
    eventName: 'custom_popup_window',
    eventKey: 'popup_reward_failed',
    msg: '伺服器匹配不上',
    code: '31003'
  },
  loadImgError: {
    eventName: 'custom_popup_window',
    eventKey: 'popup_reward_failed',
    msg: '捕获异常:图片加载失败',
    code: '31004'
  },
  loadInitDataError: {
    eventName: 'custom_popup_window',
    eventKey: 'popup_reward_failed',
    msg: '获取sdk数据错误',
    code: '31005'
  }
};

const isNative = Ctor => {
  return (
    typeof Ctor !== 'undefined' &&
    typeof Ctor === 'function' &&
    /native code/.test(Ctor.toString())
  );
};

const sleep = async second => {
  return new Promise(resolve => {
    setTimeout(resolve, second * 1000);
  });
};

export default () => {
  const hideCloseBtn = +globalConfig.getHrefParam('sdkShowCloseBtn') || 0; // 隐藏关闭按钮
  const hideBg = +globalConfig.getHrefParam('hideBg') || 0; // 隐藏背景遮罩

  const IS_ANDROID = globalConfig.getHrefParam('devicePlate') == 'android';

  const tpInfo = {
    adList: [],
    hideWithinDays: 0,
    delayTime: 0
  };

  // 弹屏初始化
  // 1、先找sdk获取这个弹屏的相关配置信息
  // 2、向sdk发送请求展示这个弹屏
  // 3、上报
  const init = (gameId, beforeCallbackFn, afterCallbackFn) => {
    bridge.callSdkMethod('initPopupInfo', {}, async res => {
      tpInfo.delayTime = +res.delayTime || 0;
      tpInfo.hideWithinDays = +res?.adList?.[0]?.isClickHide || 0;
      tpInfo.adList = res?.adList || [];
      if (
        Object.prototype.toString.call(beforeCallbackFn) == '[object Function]'
      ) {
        beforeCallbackFn(res);
      }
      await sleep(tpInfo.delayTime);
      bridge.callSdkMethod('onPopupWindowFinished', {});
      try {
        // window.sdkpopupDataLayer.push({
        //   popupId: res?.adList?.[0]?.popupId || '',
        //   gameId:
        //     gameId ||
        //     globalConfig.getHrefParam('gameId') ||
        //     globalConfig.getHrefParam('game_id') ||
        //     globalConfig.getHrefParam('gameID') ||
        //     '',
        //   eventName: 'show',
        //   loginAccount: globalConfig.getHrefParam('loginAccount') || ''
        // });
        if (
          Object.prototype.toString.call(afterCallbackFn) == '[object Function]'
        ) {
          afterCallbackFn(res);
        }
      } catch (e) {}
    });
    try {
      if (!isNative(Proxy)) {
        // window.dataLayer.push({
        //   event: 'noSupportProxy'
        // });
      }
    } catch (error) {
      // window.dataLayer.push({
      //   event: 'noSupportProxy',
      //   val: JSON.stringify(error)
      // });
    }
  };

  // 修改「近期不再显示」调用
  //是否勾选，true勾选，false没勾选
  const disableNearFuture = (checked = false) => {
    bridge.callSdkMethod('hideWindowWithinDays', {
      checked: +!!checked,
      days: tpInfo.hideWithinDays,
      popupEvent: tpInfo.adList[0].eventName,
      popupIds: tpInfo.adList[0].popupId
    });
  };

  // 关闭弹屏
  const sdkCloseWebview = () => {
    sdkSendData({ type: 'close' });
    if (IS_ANDROID) {
      window.sdkCtrl.closeWebview();
    } else {
      bridge.callSdkMethod('closeWebview');
    }
  };

  const trackEventSend = info => {
    let { type } = info;

    if (!Object.prototype.hasOwnProperty.call(EVENT_MAP, type)) {
      type = 'error';
    }

    if (
      Object.prototype.hasOwnProperty.call(EVENT_MAP[type], 'msg') &&
      Object.prototype.hasOwnProperty.call(EVENT_MAP[type], 'code')
    ) {
      info.msg = EVENT_MAP[type].msg;
      info.code = EVENT_MAP[type].code;
    }
    // window.dataLayer.push({
    //   event: TRACK_EVENT,
    //   eventName: EVENT_MAP[type].eventName,
    //   eventKey: EVENT_MAP[type].eventKey,
    //   ...info
    // });
    bridge.callSdkMethod(TRACK_EVENT, {
      eventName: EVENT_MAP[type].eventName,
      eventKey: EVENT_MAP[type].eventKey,
      eventValue: {
        ...info
      }
    });
  };

  const adClickSend = info => {
    // window.dataLayer.push({
    //   event: NOTIFY_VISIT,
    //   ...info
    // });
    bridge.callSdkMethod(NOTIFY_VISIT, {
      ...info
    });
  };

  // 向sdk发送数据
  const sdkSendData = info => {
    const { type } = info;
    type === 'adClick' ? adClickSend(info) : trackEventSend(info);
  };

  const sendVisitClickData = info => {
    bridge.callSdkMethod(NOTIFY_VISIT, info);
  };

  const sendCustomClickData = info => {
    bridge.callSdkMethod(TRACK_EVENT, info);
  };

  return {
    init,
    disableNearFuture,
    sdkCloseWebview,
    sendVisitClickData,
    sendCustomClickData,
    sdkSendData,
    adClickSend,
    trackEventSend,
    hideCloseBtn,
    hideBg,
    tpInfo
  };
};
